export default __webpack_public_path__ + "static/media/GreyDot.a4dcfafa.svg";